export default __webpack_public_path__ + "static/media/FlyingFrog3.d513880f.png";